import React, { FC } from 'react';
import ControlGroup from '../../ControlGroup';
import Checkbox from '../../../components/Checkbox';
import { getDisabledProp } from '../utils';
import FormErrorsPreviewErrorTarget
	from '../../../modules/detailPage/components/FormErrorsPreview/FormErrorsPreviewErrorTarget';
import { ValidationMessage } from '../../ValidationMessage';
import { CheckboxProps } from '../../Checkbox/types';
import { FormFieldAdapterProps } from '../../CustomForm';
import { getPreviewModeProp } from '../../CustomForm/adapters/utils/base';

type CheckboxAdapterProps = FormFieldAdapterProps<
	CheckboxProps & {
	label?: CheckboxProps['label'];
}
>;

const CheckboxAdapter: FC<CheckboxAdapterProps> = (props) => {
	const {
		input,
		meta: { invalid, touched, error },
		metadata,
		componentProps,
		controlProps,
	} = props;
	const { value, name, onChange } = input;
	const showValidation = props.immediateValidation ? invalid : invalid && touched;

	// By default, the ControlGroup component's `labelLight` prop is set to true for most components.
	// However, Checkbox is an exception, we explicitly set `labelLight` to false unless specified otherwise.
	// This ensures consistency with the design where Checkbox components should NOT have the "light label" style by default.
	const labelLight = controlProps?.labelLight ?? false;

	return (
		<ControlGroup
			{...controlProps}
			labelLight={labelLight}
			valid={!showValidation}
			validationMessage={<ValidationMessage keyCode={error} />}
		>
			<FormErrorsPreviewErrorTarget targetName={name}>
				<Checkbox
					{...componentProps}
					previewMode={getPreviewModeProp({
						metadataPreviewMode: metadata?.previewMode,
						previewMode: props.previewMode,
					})}
					disabled={getDisabledProp({ metadataDisabled: metadata?.disabled, disabled: props.disabled })}
					name={name}
					label={componentProps?.label}
					checked={!!value}
					onChange={(value) => onChange(value)}
				/>
			</FormErrorsPreviewErrorTarget>
		</ControlGroup>
	);
};

export { CheckboxAdapter };
export default CheckboxAdapter;
